// extracted by mini-css-extract-plugin
module.exports = {"container":"RegistrationForm_container__2oIma","registrationScreen":"RegistrationForm_registrationScreen__1KrrG"};